import React from "react";
import {Carousel, Modal} from "react-bootstrap";
import styles from "./ModalMaximizar.module.css"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import ImageZoom from "react-image-zooom";

export default ({show, onHide, imagenes}) => {

    return <Modal className={`modal-maximizar`} show={show} onHide={onHide}>
        <div className="modal-body">
            <div className={`d-flex justify-content-end mt-2 mr-2`}>
                <FontAwesomeIcon onClick={onHide} className={`${styles.closeIcon}`} icon={solid('close')} size={`1x`}/>
            </div>
            <Carousel fade={true} interval={null} contentEditable={false} className={`${styles.carouselColor}`}>
                {
                    imagenes.map((element, index) => {
                        return (
                            <Carousel.Item key={index}>
                                <div className={"w-100 d-flex justify-content-center"}>
                                    <div className={"w-75 text-center"}>
                                        <ImageZoom src={element} zoom={200} alt={"page"} />
                                    </div>
                                </div>
                            </Carousel.Item>
                        )
                    })
                }
            </Carousel>
        </div>
    </Modal>
}
